import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import * as React from "react";
import MenuBar from "components/mnl/global/menuBar";
import { theme } from "components/mnl/global/theme";
import TableLayout from "views/mnl/layout/tableLayout";
import V2sessionTimeout from "components/mnl/global/v2SessionTimeout";
import GetAllSupplyRequest from "components/mnl/supplyRequest/getAllSupplyRequest";

const SupplyRequestPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex", marginBottom: "70px" }}>
        <CssBaseline />
        <MenuBar pageName={"Supply Request"} />
        <TableLayout>
          <GetAllSupplyRequest />
        </TableLayout>
      </Box>
      <V2sessionTimeout />
    </ThemeProvider>
  );
};

export default SupplyRequestPage;
